import { Store } from 'vuex'
import { AxiosInstance } from 'axios'
import { Router } from 'vue-router'
import { instanceAuth } from '@/model/api/apibase'
import { State as StoreState } from '@/store/index'
import API_URL from '@/model/api/apiUrlType'

/**
 * ユーザーログアウトの関数を返す
 * @param router vueRouter
 * @param store vuex
 * @returns ユーザーログアウトの関数
 */
const useUserLogout = (router: Router, store: Store<StoreState>) => {
  // API通信インスタンス
  const instance: AxiosInstance | undefined = instanceAuth(router, store)

  /**
   * ユーザーログアウト処理のAPIを実施
   */
  const post = async () => {
    // 戻り値
    let isNormal = true
    // 認証後のaxiosインスタンス取得
    const obj = instance
    await obj
      .post(
        API_URL.USERS.LOGOUT // URL
      )
      .then(() => {
        // 成功時は戻り値をtrueにするだけ
        isNormal = true
      })
      .catch(() => {
        // ログアウト失敗時は正常・異常に関わらずTOP画面に戻すので戻り値をfalseにするだけ
        isNormal = false
      })
    return {
      isNormal,
    }
  }
  return {
    instance,
    post,
  }
}

export {
  useUserLogout, //
}
